export default [
  {
    phoneNumber: "1234567894",
    role: "employee",
    pronoun: "Mr.",
    userId: "c768b3b1-e1ad-4677-9366-235ca0152317",
    tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
    given_name: "Clint",
    createdAt: "2022-03-15T18:10:25.370Z",
    family_name: "Barton",
    associatedEvents: [
      {
        key: {
          tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
          userId: "event1649788277666",
        },
        role: "employee",
      },
    ],
    username: "clint.barton@simplecitysoftware.com",
    email: "clint.barton@simplecitysoftware.com",
  },
  {
    phoneNumber: "1234567894",
    role: "client",
    userId: "3666df24-41b5-47b9-a157-7cdb54ce4056",
    notes: [
      {
        date: "2022-12-09T17:03:35.927Z",
        body: "This is a note, Steven",
        tenant: "f48f259e-37d9-4003-be97-7181858b98aa",
      },
    ],
    tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
    given_name: "Steve",
    createdAt: "2022-03-15T18:36:00.846Z",
    family_name: "Rogers",
    associatedEvents: [
      "event1647368940289",
      {
        key: {
          tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
          userId: "event1649788277666",
        },
        role: "client",
      },
    ],
    username: "steve.rogers@simplecitysoftware.com",
    email: "steve.rogers@simplecitysoftware.com",
  },
  {
    phoneNumber: "1234567890",
    tenants: [
      "7e9b6fe0-0b16-4076-8171-a399992d876b",
      "12d988e1-ebec-45a6-8bd6-c091e42da627",
      "f48f259e-37d9-4003-be97-7181858b98aa",
      "f48f259e-37d9-4003-be97-7181858b98aa",
      "f48f259e-37d9-4003-be97-7181858b98aa",
      "f48f259e-37d9-4003-be97-7181858b98aa",
      "f48f259e-37d9-4003-be97-7181858b98aa",
      "f48f259e-37d9-4003-be97-7181858b98aa",
    ],
    tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
    given_name: "Bruce",
    createdAt: "2022-03-15T18:43:25.671Z",
    family_name: "Banner",
    email: "bruce.banner@simplecitysoftware.com",
    conversations: [
      {
        id: "1654284404134",
        sortKey: "b351c34f-3217-49a3-83d7-b5134ac73b7c",
      },
      {
        id: "1654284487446",
        sortKey: "b351c34f-3217-49a3-83d7-b5134ac73b7c",
      },
      {
        id: "1654284489127",
        sortKey: "b351c34f-3217-49a3-83d7-b5134ac73b7c",
      },
    ],
    role: "client",
    userId: "b351c34f-3217-49a3-83d7-b5134ac73b7c",
    associatedEvents: [
      {
        key: {
          tenantId: "7e9b6fe0-0b16-4076-8171-a399992d876b",
          userId: "event1643075534547",
        },
        role: "client",
      },
      {
        key: {
          tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
          userId: "event1649788277666",
        },
        role: "client",
      },
      {
        key: {
          tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
          userId: "event1647365654337",
        },
        role: "client",
      },
      {
        key: {
          tenantId: "7e9b6fe0-0b16-4076-8171-a399992d876b",
          userId: "event1644173564641",
        },
        role: "client",
      },
      {
        key: {
          tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
          userId: "event1671221108013",
        },
        role: "client",
      },
      {
        key: {
          tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
          userId: "event1672948593961",
        },
        role: "client",
      },
      {
        key: {
          tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
          userId: "event1672949309557",
        },
        role: "client",
      },
      {
        key: {
          tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
          userId: "event1672949400312",
        },
        role: "client",
      },
      {
        key: {
          tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
          userId: "event1672949557461",
        },
        role: "client",
      },
      {
        key: {
          tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
          userId: "event1672949746795",
        },
        role: "client",
      },
      {
        key: {
          tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
          userId: "event1672950892190",
        },
        role: "client",
      },
      {
        key: {
          tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
          userId: "event1672951295571",
        },
        role: "client",
      },
      {
        key: {
          tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
          userId: "event1673026067382",
        },
        role: "client",
      },
    ],
    username: "bruce.banner@simplecitysoftware.com",
  },
  {
    phoneNumber: "1234567894",
    role: "employee",
    pronoun: null,
    userId: "df5be583-c78f-4afb-906f-49f63916fd32",
    tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
    given_name: "Thor",
    createdAt: "2022-03-15T18:23:52.713Z",
    family_name: "Odinson",
    associatedEvents: [
      {
        key: {
          tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
          userId: "event1649788277666",
        },
        role: "employee",
      },
    ],
    username: "thor.odinson@simplecitysoftware.com",
    email: "thor.odinson@simplecitysoftware.com",
  },
  {
    phoneNumber: "1234567894",
    tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
    given_name: "Tony",
    createdAt: "2022-03-15T18:22:41.622Z",
    family_name: "Stark",
    email: "tony.stark@simplecitysoftware.com",
    conversations: [
      {
        id: "1655489927039",
        sortKey: "f48f259e-37d9-4003-be97-7181858b98aa",
      },
    ],
    role: "client",
    pronoun: "Mr.",
    profilePicture:
      "https://spindjappstorage140016-prod.s3.amazonaws.com/public/f48f259e-37d9-4003-be97-7181858b98aa1656115623113",
    userId: "87da40f6-7074-494f-b04f-b6f779b51c8b",
    associatedEvents: [
      {
        key: {
          tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
          userId: "event1648165291492",
        },
        role: "client",
      },
      {
        key: {
          tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
          userId: "event1649788567110",
        },
        role: "client",
      },
      {
        key: {
          tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
          userId: "event1649788723748",
        },
        role: "client",
      },
      {
        key: {
          tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
          userId: "event1649788971974",
        },
        role: "client",
      },
      {
        key: {
          tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
          userId: "event1649789298650",
        },
        role: "client",
      },
      {
        key: {
          tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
          userId: "event1649789298650",
        },
        role: "client",
      },
      {
        key: {
          tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
          userId: "event1649789510007",
        },
        role: "client",
      },
      {
        key: {
          tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
          userId: "event1649789696173",
        },
        role: "client",
      },
      {
        key: {
          tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
          userId: "event1649789901628",
        },
        role: "client",
      },
      {
        key: {
          tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
          userId: "event1649863798490",
        },
        role: "client",
      },
      {
        key: {
          tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
          userId: "event1649864026900",
        },
        role: "client",
      },
      {
        key: {
          tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
          userId: "event1649864140838",
        },
        role: "client",
      },
      {
        key: {
          tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
          userId: "event1647365654337",
        },
        role: "client",
      },
      {
        key: {
          tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
          userId: "event1664556591573",
        },
        role: "client",
      },
      {
        key: {
          tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
          userId: "event1647369651738",
        },
        role: "client",
      },
      {
        key: {
          tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
          userId: "event1649788277666",
        },
        role: "client",
      },
    ],
    username: "tony.stark@simplecitysoftware.com",
  },

  {
    phoneNumber: "1234567894",
    tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
    given_name: "Natasha",
    createdAt: "2022-03-15T18:51:48.425Z",
    family_name: "Romanoff",
    email: "natasha.romanoff@simplecitysoftware.com",
    conversations: [
      {
        id: "1656107697256",
        sortKey: "f48f259e-37d9-4003-be97-7181858b98aa",
      },
    ],
    role: "client",
    pronoun: "Ms",
    profilePicture:
      "https://spindjappstorage140016-prod.s3.amazonaws.com/public/f48f259e-37d9-4003-be97-7181858b98aa1656113561338",
    userId: "978df7f1-893b-46ae-8764-6be7d3f5f642",
    associatedEvents: [
      "event1647370125074",
      {
        key: {
          tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
          userId: "event1649788277666",
        },
        role: "client",
      },
      {
        key: {
          tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
          userId: "event1647368940289",
        },
        role: "client",
      },
      {
        key: {
          tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
          userId: "event1656092345238",
        },
        role: "client",
      },
    ],
    username: "natasha.romanoff@simplecitysoftware.com",
  },
  {
    phoneNumber: "1234567894",
    tenants: ["7e9b6fe0-0b16-4076-8171-a399992d876b"],
    vendorCategory: "Decor/Florist",
    tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
    given_name: "Peter",
    createdAt: "2022-03-15T18:15:38.906Z",
    family_name: "Parker",
    email: "peter.parker@simplecitysoftware.com",
    conversations: [
      {
        id: "1656116593540",
        sortKey: "f48f259e-37d9-4003-be97-7181858b98aa",
      },
    ],
    role: "vendor",
    pronoun: "Mr.",
    profilePicture:
      "https://spindjappstorage140016-prod.s3.amazonaws.com/public/f48f259e-37d9-4003-be97-7181858b98aa1656116885967",
    userId: "de8abc34-2c29-4aef-ad71-26187c82fe11",
    associatedEvents: [
      "event1647369651738",
      {
        key: {
          tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
          userId: "event1648165291492",
        },
        role: "vendor",
      },
      {
        key: {
          tenantId: "7e9b6fe0-0b16-4076-8171-a399992d876b",
          userId: "event1643075534547",
        },
        role: "vendor",
      },
      {
        key: {
          tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
          userId: "event1647365654337",
        },
        role: "vendor",
      },
      {
        key: {
          tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
          userId: "event1649788567110",
        },
        role: "vendor",
      },
    ],
    username: "peter.parker@simplecitysoftware.com",
  },
];
